import {useIsFetching} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import FullScreenLoader from './FullScreenLoader';

function GlobalLoader() {
  const fetching = useIsFetching({
    predicate: (query) => query.meta?.showGlobalLoader !== false,
  }); // total active queries
  const busy = fetching > 0;

  // debounce (optional): show after 150ms to avoid flicker
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let t: any;
    if (busy) {
      t = setTimeout(() => setVisible(true), 150);
    } else {
      setVisible(false);
    }
    return () => clearTimeout(t);
  }, [busy]);

  return visible ? <FullScreenLoader open /> : null;
}

export default GlobalLoader;
